import { Configuration } from "@docket/consumer-app-client-typescript-axios";
import { API_DOMAIN, PROTOCOL, STAGE } from "../../globals";
import VERSION from "../../version";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

const getUserAgent = async () => {
  if (Capacitor.isNativePlatform()) {
    const version = await App.getInfo();
    const mobileVersion = version.version + STAGE[0].toUpperCase() + version.build;
    return `DocketCapacitor/1.0-${mobileVersion} ${Capacitor.getPlatform()}`;
  }
  return `DocketPWA/1.0-${VERSION}`;
};

export const getBaseConfigOptions = async (): Promise<
  Pick<Configuration, "basePath" | "baseOptions">
> => {
  return {
    basePath: `${PROTOCOL}://${API_DOMAIN}`,
    baseOptions: {
      headers: {
        "X-User-Agent": await getUserAgent(),
      },
    },
  };
};

export default async () => new Configuration(await getBaseConfigOptions());
